import { GestureResponderEvent } from 'react-native-modal';
import { DialogButton, DialogOptions } from './types';

type DialogButtons = {
  confirm?: DialogButton;
  cancel?: DialogButton;
};

// Shared by the cancel button and the corner X so dismissing via the X can
// never skip a cancelAction's side-effects.
export function resolveCancelPress(
  options: DialogOptions,
  onClose: (() => void) | undefined,
): (e?: GestureResponderEvent) => void {
  const { cancelAction } = options;
  return (e) =>
    cancelAction?.onPress ? cancelAction.onPress(e, onClose) : onClose?.();
}

// Cancel is unified (both apps) — gated by showCancelButton. Confirm stays
// per-app: therapist always shows a confirm button ("Ok" fallback), patient
// only via confirmAction or the showOkButton fallback.
export function createDialogButtons(
  options: DialogOptions,
  onClose: (() => void) | undefined,
  isPatientApp: boolean,
): DialogButtons {
  const {
    danger = false,
    confirmAction,
    cancelAction,
    showOkButton = true,
    showCancelButton = false,
  } = options;

  let confirm: DialogButton | undefined;
  if (confirmAction) {
    confirm = {
      testID: confirmAction.testID ?? 'confirm-modal',
      danger,
      label: confirmAction.label,
      disabled: confirmAction.disabled,
      onPress: (e) => confirmAction.onPress(e, onClose),
    };
  } else if (!isPatientApp) {
    confirm = { danger, label: 'Ok', onPress: () => onClose?.() };
  } else if (!cancelAction && showOkButton) {
    confirm = { danger, label: 'OK', onPress: () => onClose?.() };
  }

  let cancel: DialogButton | undefined;
  if (showCancelButton) {
    cancel = {
      testID: cancelAction?.testID,
      label: cancelAction?.label ?? 'Abbrechen',
      onPress: resolveCancelPress(options, onClose),
    };
  }

  return { confirm, cancel };
}
